"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fold = exports.getEmail = exports.isPending = exports.pending = exports.isLoggedOut = exports.loggedOut = exports.isLoggedIn = exports.loggedIn = exports.refreshedTokenDecoder = exports.idTokenDecoder = exports.decoder = exports.getGreeting = void 0;
var Greeting_1 = require("./Greeting");
Object.defineProperty(exports, "getGreeting", { enumerable: true, get: function () { return Greeting_1.getGreeting; } });
var data_1 = require("./data");
Object.defineProperty(exports, "decoder", { enumerable: true, get: function () { return data_1.statusDecoder; } });
Object.defineProperty(exports, "idTokenDecoder", { enumerable: true, get: function () { return data_1.idTokenDecoder; } });
Object.defineProperty(exports, "refreshedTokenDecoder", { enumerable: true, get: function () { return data_1.refreshedTokenDecoder; } });
var loggedIn = function (data) { return ({
    kind: "LoggedIn",
    data: data,
}); };
exports.loggedIn = loggedIn;
var isLoggedIn = function (status) {
    return status.kind === "LoggedIn";
};
exports.isLoggedIn = isLoggedIn;
var loggedOut = function (reason, feedback) { return ({
    kind: "LoggedOut",
    reason: reason,
    feedback: feedback,
}); };
exports.loggedOut = loggedOut;
var isLoggedOut = function (status) {
    return status.kind === "LoggedOut";
};
exports.isLoggedOut = isLoggedOut;
var pending = function () { return ({ kind: "Pending" }); };
exports.pending = pending;
var isPending = function (status) {
    return status.kind === "Pending";
};
exports.isPending = isPending;
var getEmail = function (status) {
    return (0, exports.isLoggedIn)(status) ? status.data.email : undefined;
};
exports.getEmail = getEmail;
var fold = function (callbacks, status) {
    switch (status.kind) {
        case "Pending":
            return callbacks.pending();
        case "LoggedOut":
            return callbacks.loggedOut(status.reason);
        case "LoggedIn":
            return callbacks.loggedIn(status.data);
    }
};
exports.fold = fold;
